import { type RawPreambleData, type StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import { Richtext } from 'storyblok-js-client';

export type PreambleType = {
    component: 'preamble';
    id: string;
    sbEditable?: StoryblokEditable;
    text: Richtext;
};

type TransformPreambleProps = {
    preamble: RawPreambleData | RawPreambleData[] | undefined;
};

const transformPreamble = ({ preamble }: TransformPreambleProps): PreambleType | undefined => {
    if (!preamble || (Array.isArray(preamble) && !preamble?.[0])) {
        return;
    }

    const preambleData = Array.isArray(preamble) ? preamble[0] : preamble;
    const { _uid, _editable, component, preamble: text } = preambleData;

    return {
        component,
        id: _uid,
        sbEditable: transformPreviewEditable(_editable),
        text,
    };
};

export default transformPreamble;
